import { Link } from 'react-router-dom';

const SPECIALTY_GROUPS = [
  {
    heading: 'Life Insurance by Need',
    icon: 'ri-shield-check-line',
    links: [
      { href: '/life-insurance-for-families-indianapolis', label: 'Life Insurance for Families' },
      { href: '/life-insurance-for-new-parents-indianapolis', label: 'Life Insurance for New Parents' },
      { href: '/life-insurance-for-seniors-over-60-indianapolis', label: 'Life Insurance for Seniors Over 60' },
      { href: '/life-insurance-for-diabetics-indianapolis', label: 'Life Insurance for Diabetics' },
      { href: '/life-insurance-smokers-indianapolis', label: 'Life Insurance for Smokers' },
      { href: '/life-insurance-for-veterans-indianapolis', label: 'Life Insurance for Veterans' },
      { href: '/life-insurance-for-self-employed-indianapolis', label: 'Life Insurance for Self-Employed' },
      { href: '/business-life-insurance-indianapolis', label: 'Business Life Insurance' },
    ],
  },
  {
    heading: 'Quotes, Rates & Comparisons',
    icon: 'ri-bar-chart-2-line',
    links: [
      { href: '/life-insurance-quotes-indianapolis', label: 'Life Insurance Quotes Indianapolis' },
      { href: '/life-insurance-rates-indianapolis', label: 'Life Insurance Rates Indianapolis' },
      { href: '/life-insurance-comparison-indianapolis', label: 'Life Insurance Comparison Indianapolis' },
      { href: '/term-life-insurance-quotes-indianapolis', label: 'Term Life Insurance Quotes' },
      { href: '/term-life-insurance-rates-indianapolis', label: 'Term Life Insurance Rates' },
      { href: '/whole-life-insurance-quotes-indianapolis', label: 'Whole Life Insurance Quotes' },
      { href: '/affordable-life-insurance-indianapolis', label: 'Affordable Life Insurance Indianapolis' },
      { href: '/cheap-life-insurance-indianapolis', label: 'Cheap Life Insurance Indianapolis' },
    ],
  },
  {
    heading: 'Specialty Coverage Types',
    icon: 'ri-file-list-3-line',
    links: [
      { href: '/whole-life-insurance-indianapolis', label: 'Whole Life Insurance Indianapolis' },
      { href: '/final-expense-insurance-indianapolis', label: 'Final Expense Insurance Indianapolis' },
      { href: '/final-expense-insurance-quotes-indianapolis', label: 'Final Expense Insurance Quotes' },
      { href: '/burial-insurance-indianapolis', label: 'Burial Insurance Indianapolis' },
      { href: '/senior-life-insurance-indianapolis', label: 'Senior Life Insurance Indianapolis' },
      { href: '/guaranteed-issue-life-insurance-indianapolis', label: 'Guaranteed Issue Life Insurance' },
      { href: '/high-risk-life-insurance-indianapolis', label: 'High Risk Life Insurance Indianapolis' },
      { href: '/no-exam-life-insurance-indianapolis', label: 'No Exam Life Insurance Indianapolis' },
    ],
  },
  {
    heading: 'Mortgage & Home Protection',
    icon: 'ri-home-heart-line',
    links: [
      { href: '/mortgage-protection-indianapolis', label: 'Mortgage Protection Indianapolis' },
      { href: '/mortgage-protection-insurance-indianapolis', label: 'Mortgage Protection Insurance Indianapolis' },
      { href: '/mortgage-life-insurance-indianapolis', label: 'Mortgage Life Insurance Indianapolis' },
      { href: '/group-life-insurance-indianapolis', label: 'Group Life Insurance Indianapolis' },
      { href: '/best-life-insurance-indianapolis', label: 'Best Life Insurance Indianapolis' },
      { href: '/life-insurance-agent-indianapolis', label: 'Life Insurance Agent Indianapolis' },
      { href: '/term-life-insurance-indianapolis', label: 'Term Life Insurance Indianapolis' },
      { href: '/term-life-indianapolis', label: 'Term Life Indianapolis' },
    ],
  },
  {
    heading: 'Resources & Tools',
    icon: 'ri-book-open-line',
    links: [
      { href: '/resources', label: 'Life Insurance Resources' },
      { href: '/resources/life-insurance-for-smokers-indiana', label: 'Life Insurance for Smokers Indiana' },
      { href: '/resources/final-expense-insurance-indiana-seniors', label: 'Final Expense for Indiana Seniors' },
      { href: '/resources/mortgage-protection-fishers-family-story', label: 'Mortgage Protection: Fishers Story' },
      { href: '/resources/term-vs-whole-life-indianapolis-homeowners', label: 'Term vs Whole Life for Homeowners' },
      { href: '/resources/no-medical-exam-life-insurance-indiana-guide', label: 'No Medical Exam Guide Indiana' },
      { href: '/resources/life-insurance-for-seniors-indiana', label: 'Life Insurance for Seniors Indiana' },
      { href: '/resources/annuities-retirement-planning-indiana', label: 'Annuities & Retirement Planning' },
    ],
  },
  {
    heading: 'More Resources & Legal',
    icon: 'ri-links-line',
    links: [
      { href: '/resources/life-insurance-riders-indiana', label: 'Life Insurance Riders Indiana' },
      { href: '/resources/how-to-choose-life-insurance-company-indiana', label: 'How to Choose a Life Insurance Company' },
      { href: '/resources/life-insurance-for-business-owners-indiana', label: 'Life Insurance for Business Owners' },
      { href: '/resources/life-insurance-mistakes-indiana-families', label: 'Life Insurance Mistakes to Avoid' },
      { href: '/about', label: 'About Hoosier Life Insurance' },
      { href: '/contact', label: 'Contact Us' },
      { href: '/faq', label: 'Frequently Asked Questions' },
      { href: '/compare', label: 'Compare Insurance Products' },
    ],
  },
  {
    heading: 'Service Areas — Central IN',
    icon: 'ri-map-pin-2-line',
    links: [
      { href: '/service-areas', label: 'All Indiana Service Areas' },
      { href: '/service-areas/noblesville', label: 'Life Insurance Noblesville' },
      { href: '/service-areas/carmel', label: 'Life Insurance Carmel' },
      { href: '/service-areas/westfield', label: 'Life Insurance Westfield' },
      { href: '/service-areas/zionsville', label: 'Life Insurance Zionsville' },
      { href: '/service-areas/lebanon', label: 'Life Insurance Lebanon' },
      { href: '/service-areas/indianapolis', label: 'Life Insurance Indianapolis' },
      { href: '/service-areas/greenwood', label: 'Life Insurance Greenwood' },
    ],
  },
  {
    heading: 'Service Areas — More Cities',
    icon: 'ri-map-2-line',
    links: [
      { href: '/service-areas/bloomington', label: 'Life Insurance Bloomington' },
      { href: '/service-areas/geist', label: 'Life Insurance Geist' },
      { href: '/service-areas/muncie', label: 'Life Insurance Muncie' },
      { href: '/service-areas/plainfield', label: 'Life Insurance Plainfield' },
      { href: '/service-areas/lawrence', label: 'Life Insurance Lawrence' },
      { href: '/service-areas/richmond', label: 'Life Insurance Richmond' },
      { href: '/service-areas/columbus', label: 'Life Insurance Columbus IN' },
      { href: '/service-areas/terre-haute', label: 'Life Insurance Terre Haute' },
    ],
  },
  {
    heading: 'Service Areas — Suburbs',
    icon: 'ri-community-line',
    links: [
      { href: '/service-areas/castleton', label: 'Life Insurance Castleton' },
      { href: '/service-areas/kokomo', label: 'Life Insurance Kokomo' },
      { href: '/service-areas/avon', label: 'Life Insurance Avon' },
      { href: '/service-areas/broad-ripple', label: 'Life Insurance Broad Ripple' },
      { href: '/service-areas/anderson', label: 'Life Insurance Anderson' },
      { href: '/service-areas/speedway', label: 'Life Insurance Speedway' },
      { href: '/service-areas/fort-wayne', label: 'Life Insurance Fort Wayne' },
      { href: '/service-areas/brownsburg', label: 'Life Insurance Brownsburg' },
    ],
  },
  {
    heading: 'Service Areas — New Cities',
    icon: 'ri-pin-distance-line',
    links: [
      { href: '/service-areas/whitestown', label: 'Life Insurance Whitestown' },
      { href: '/service-areas/beech-grove', label: 'Life Insurance Beech Grove' },
      { href: '/service-areas/mooresville', label: 'Life Insurance Mooresville' },
      { href: '/service-areas/fishers', label: 'Life Insurance Fishers' },
      { href: '/service-areas/franklin', label: 'Life Insurance Franklin IN' },
      { href: '/service-areas/cumberland', label: 'Life Insurance Cumberland IN' },
      { href: '/service-areas/greenfield', label: 'Life Insurance Greenfield IN' },
      { href: '/service-areas/danville', label: 'Life Insurance Danville IN' },
    ],
  },
  {
    heading: 'City Specialty Pages',
    icon: 'ri-building-2-line',
    links: [
      { href: '/hamilton-county-life-insurance', label: 'Hamilton County Life Insurance' },
      { href: '/fishers-life-insurance', label: 'Fishers Life Insurance' },
      { href: '/noblesville-life-insurance', label: 'Noblesville Life Insurance' },
      { href: '/carmel-life-insurance', label: 'Carmel Life Insurance' },
      { href: '/service-areas/martinsville', label: 'Life Insurance Martinsville IN' },
      { href: '/service-areas/marion-county', label: 'Life Insurance Marion County' },
      { href: '/ai-employee', label: 'AI Insurance Assistant' },
      { href: '/service-areas/marion-county', label: 'Marion County Coverage' },
    ],
  },
  {
    heading: 'Resources & Calculators',
    icon: 'ri-calculator-line',
    links: [
      { href: '/resources/life-insurance-checklist-indiana', label: 'Life Insurance Checklist Indiana' },
      { href: '/resources/life-insurance-glossary-indiana', label: 'Life Insurance Glossary Indiana' },
      { href: '/resources/indiana-life-insurance-calculator', label: 'Indiana Life Insurance Calculator' },
      { href: '/resources/how-much-life-insurance-indiana-families-need', label: 'How Much Life Insurance Indiana' },
      { href: '/resources/life-insurance-for-business-owners-indiana', label: 'Life Insurance for Business Owners' },
      { href: '/resources/life-insurance-mistakes-indiana-families', label: 'Life Insurance Mistakes to Avoid' },
      { href: '/resources/life-insurance-riders-indiana', label: 'Life Insurance Riders Indiana' },
      { href: '/resources/how-to-choose-life-insurance-company-indiana', label: 'How to Choose a Life Insurance Company' },
    ],
  },
  {
    heading: 'More Pages',
    icon: 'ri-pages-line',
    links: [
      { href: '/all-services', label: 'All Services Directory' },
      { href: '/sitemap', label: 'HTML Sitemap' },
      { href: '/quiz', label: 'Life Insurance Quiz' },
      { href: '/term-vs-whole-life', label: 'Term vs Whole Life Guide' },
      { href: '/generational-wealth', label: 'Generational Wealth Planning' },
      { href: '/universal-life', label: 'Universal Life Insurance' },
      { href: '/privacy-policy', label: 'Privacy Policy' },
      { href: '/terms-of-service', label: 'Terms of Service' },
    ],
  },
];

export default function SpecialtyCoverageLinks() {
  return (
    <section className="py-16 bg-[#F9F7F4] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block text-[11px] font-bold tracking-widest text-[#D97642] uppercase mb-3">
            Complete Coverage Directory
          </span>
          <h2 className="text-2xl font-bold text-[#1A3A52] mb-2">
            Find the Right Life Insurance for Your Situation
          </h2>
          <p className="text-sm text-gray-500 max-w-xl mx-auto">
            Browse all coverage types, specialty pages, and Indiana service areas — every page organized by topic.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {SPECIALTY_GROUPS.map((group) => (
            <div key={group.heading}>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${group.icon} text-[#D97642] text-base`}></i>
                </div>
                <h3 className="text-[12px] font-bold text-[#1A3A52] uppercase tracking-wide">
                  {group.heading}
                </h3>
              </div>
              <ul className="space-y-1.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-[12px] text-gray-600 hover:text-[#D97642] transition-colors leading-snug block"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
